import './KeywordFeatures.scss'
import { useState } from 'react'
import { serpIcons } from '../../utils/Utils'
import { Avatar, Box, Skeleton, Typography } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'

const MAX_VISIBLE_FEATURES = 9;

const KeywordFeatures = ({ data }: { data: string[] }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!data) return '—';

  if (data.length === 0) {
    return (
      <div className="flex gap-1">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} variant="circular" width={20} height={20} />
        ))}
      </div>
    );
  }

  const canExpand = data.length > MAX_VISIBLE_FEATURES;
  const featuresToShow = isExpanded ? data : data.slice(0, MAX_VISIBLE_FEATURES);
  const hiddenCount = data.length - MAX_VISIBLE_FEATURES;

  // Determine icon size dynamically. They are smaller when expanded.
  const iconSize = isExpanded ? '1px' : '0rem';

  return (
    <Box className={'keywordFeatures'}   sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      py: 0,
    }}
    >
      {featuresToShow.map((item) => (
        <Tooltip
          title={
            <>
              <Typography component="div" sx={{ fontWeight: 'bold', mb: 0.5, color: 'white' }}>
                {t(`snippet.${item}.title`)}
              </Typography>
              {t(`snippet.${item}.description`)}
            </>
          }
          arrow
          followCursor
          className="serp-features"
          key={item}
        >

        <Typography sx={{ fontSize: iconSize, transition: 'font-size 0.2s ease-in-out' }}>
            {serpIcons[item] || item}
          </Typography>
        </Tooltip>
      ))}
      {canExpand && !isExpanded && (
        <Tooltip title={t('showAllSnippets')} arrow followCursor>
          <Avatar className={'snippets-count'}
            sx={{ width: 20, height: 24, fontSize: '0.625rem', bgcolor: 'action.hover', color: 'text.primary', cursor: 'pointer' }}
            onClick={() => setIsExpanded(true)}
          >
            +{hiddenCount}
          </Avatar>
        </Tooltip>
      )}
    </Box>
  )
}

export default KeywordFeatures